export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE'
